import { axiosInstance } from '@/lib/axios'
import { DriverChartDetailsRow } from './types'

const base = (companyId: string | number) => `/api/${companyId}/activity`

// GET /api/{companyId}/activity/chart-details — the WPF "Dane z kart kierowców
// i wykresówek" grid for one or more drivers over a date range (analog + digital merged).
// driverIds is serialized as repeated query params (driverIds=1&driverIds=2).
// startTime/endTime are ISO date strings, e.g. "2025-09-01".
export function getDriverChartDetails(
  companyId: string | number,
  driverIds: number[],
  startTime: string,
  endTime: string,
) {
  // Build the query manually so the array repeats the key (driverIds=1&driverIds=2),
  // which is what ASP.NET model binding expects for int[] — independent of axios version.
  const qs = new URLSearchParams()
  driverIds.forEach((id) => qs.append('driverIds', String(id)))
  qs.append('startTime', startTime)
  qs.append('endTime', endTime)
  return axiosInstance.get<DriverChartDetailsRow[]>(
    `${base(companyId)}/chart-details?${qs.toString()}`,
  )
}

export type ChartDeleteItem = { chartId: number; driverId: number }

// POST /api/{companyId}/activity/chart-details/delete — deletes selected analog charts
// and recalculates violations for affected drivers (WPF "Usuń wybrane" + save).
export function deleteChartDetails(
  companyId: string | number,
  items: ChartDeleteItem[],
) {
  return axiosInstance.post(`${base(companyId)}/chart-details/delete`, { items })
}
